// extracted by mini-css-extract-plugin
export default {"modelName":"ModelSwitcher-module__modelName--EXlIE","selectAnchor":"ModelSwitcher-module__selectAnchor--RQ84R"};